export default "__VITE_ASSET__lrVFBVW6__"